import React from 'react'
import { SGPageTemplateContentEntry } from '../../../types/page-templates'

export const AsMeasured: React.FC<{
  metadata?: SGPageTemplateContentEntry['analyticsMetadata']
  slot?: string
  [key: string]: any
}> = ({ metadata, slot, children, ...props }) => (
  <div
    {...props}
    {...(metadata && slot
      ? {
          'data-promotion': true,
          'data-trackable-action': 'ga.event.viewPromotion',
          'data-trackable-correlation-id': metadata.correlationId,
          'data-promotion-id': metadata.correlationId,
          'data-promotion-name': metadata.title,
          'data-promotion-creative': metadata.promotion.creative,
          'data-promotion-slot': slot,
        }
      : {})}
  >
    {children}
  </div>
)
